import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { InputWidth } from '../../../../types/aoraki/input-width-types'
import { WellheadSecuritySubFormProps } from './well-head-security-view-quality'

export default function WellheadSecurityViewConstruction({ isLoading, fields }: WellheadSecuritySubFormProps) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Wellhead construction
      </Heading>

      <FormField
        toolTipMessage={TOOLTIP.wellCap}
        isSkeleton={isLoading}
        labelId='wellheadConstructionCapped'
        label='Well cap'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='wellheadConstructionCapped' value={fields?.wellCap} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.sealAroundWellhead}
        isSkeleton={isLoading}
        labelId='sealAroundWellhead'
        label='Seal around wellhead'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='sealAroundWellhead' value={fields?.sealAroundWellhead} />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='concretePad' label='Concrete pad'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='concretePad' value={fields?.concretePad} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.bungsSealed}
        isSkeleton={isLoading}
        labelId='bungsSealed'
        label='Bungs / ports securely sealed'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='bungsSealed' value={fields?.bungsSealed} />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='wellUpstand' label='Upstand 0.3m or greater above ground level'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='wellUpstand'
          value={fields?.isWellUpstand03M}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='installedInFrostPit' label='Installed in frost pit'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='installedInFrostPit'
          value={fields?.isWellInstalledInFrostPit}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='groundwaterLevelAccess' label='Groundwater level access'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='groundwaterLevelAccess'
          value={fields?.accessForWaterLevelMeasurement}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.samplingTapLocation}
        isSkeleton={isLoading}
        labelId='samplingTapLocation'
        label='Sample point description'
      >
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='samplingTapLocation'
          value={fields?.samplingTapLocation ?? ''}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='pumpType' label='Pump type'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='pumpType' value={fields?.pumpType ?? ''} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.pumpInstallDepth}
        isSkeleton={isLoading}
        labelId='pumpInstallDepth'
        label='Pump install depth'
      >
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='pumpInstallDepth'
          value={fields?.pumpInstallDepth ?? ''}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='backflowPrevention' label='Backflow prevention'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='backflowPrevention'
          value={fields?.backflowPrevention ?? ''}
        />
      </FormField>
    </>
  )
}
